<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="box">
                <div class="box-offset">
                    <div class="box-ttl-wrap">
                        <div class="box-ttl">New Uniform</div>
                    </div>
                    <div class="form mt-3">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group form-group-2">
                                    <p>{{ userName }}</p>
                                </div>
                            </div>
                            <div class="col-md-12 d-flex flex-wrap">
                                <div class="form-group form-group-2 mr-4">
                                    <label for="" class="form-label">Do you want this uniform to be delivered to your
                                        primary location or to the main office?</label>
                                </div>
                                <div class="d-flex">
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio"
                                                name="name12"
                                                id="office"
                                                :value="true"
                                                v-model="request.isMainOffice"
                                                @change="request.location === null"
                                            >
                                            <label class="form-check-label" for="office">
                                                <nobr> Main Office</nobr>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="form-group form-group-2 mr-3">
                                        <div class="form-check">
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio" name="name12"
                                                id="primary"
                                                :value="false"
                                                v-model="request.isMainOffice"
                                            >
                                            <label class="form-check-label" for="primary">
                                                <nobr>Primary Location</nobr>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12" v-if="request.isMainOffice === false">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Primary Location</label>
                                    <select class="form-control" v-model="request.location">
                                        <option
                                            v-for="client in clientsList"
                                            :key="client.id"
                                            :value="client.id"
                                        >
                                            {{ client.name }}
                                        </option>
                                    </select>
                                    <small>Please keep in mind each location and position has specific requirement. If
                                        you request an time that is not part of YOUR location’s uniform, your request
                                        will be denied.</small>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="table-holder table-responsive ">
                                    <table class="table ">
                                        <thead>
                                        <tr>
                                            <th>Inventory Item</th>
                                            <th style="width: 7rem">Size</th>
                                            <th style="width: 6rem">Quantity</th>
                                            <th style="width: 4rem"></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="item in request.uniforms" :key="item.id">
                                            <td>{{ item.title }}</td>
                                            <td class="form-control">
                                                <div class="form-group form-group-2 mb-0">
                                                    <b>{{ item.size }}</b>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-2 mb-0">
                                                    <b>{{ item.quantity }}</b>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="action-block">
                                                    <button class="delete-link "><img
                                                        src="/img/svg/on.svg" alt=""
                                                        @click.prevent="removeItem"
                                                    ></button>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr class="new-item-row" v-if="showTypeInput">
                                            <td>
                                                <div class="form-group form-group-2 mb-0">
                                                    <input type="text" class="form-control"
                                                           placeholder="Type Inventory Name "
                                                           v-model="searchTerm"
                                                           @input="handleSearch"
                                                    >
                                                    <ul
                                                        v-show="showResults"
                                                        class="search-results"
                                                    >
                                                        <li v-for="result in filteredUniformsList"
                                                            :key="result.id"
                                                            @click="selectResult(result)">
                                                            {{ result.title }}
                                                        </li>
                                                    </ul>
                                                </div>

                                            </td>
                                            <td>
                                                <div class="form-group form-group-2 mb-0">
                                                    <input type="text" class="form-control" v-model="uniform.size">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="form-group form-group-2 mb-0">
                                                    <input type="number" min="0" class="form-control"
                                                           v-model.number="uniform.quantity">
                                                </div>
                                            </td>
                                            <td>
                                                <div class="action-block">
                                                    <button class="edit-link" @click="saveItem">
                                                        <img src="/img/svg/check-5.svg" alt="Save">
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 text-right mb-4">
                                <a href="javascript:void(0)"
                                   class="btn btn--outline-primary btn--middle"
                                   @click="addNewItem"
                                >+ Add New</a>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group form-group-2">
                                    <label for="" class="form-label">Comment</label>
                                    <textarea type="text" class="form-control height-2"
                                              v-model="request.comment"></textarea>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <a href="/application/profile?tab=Uniforms"
                                       class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                    <a class="btn btn--secondary w-100 w-sm-auto" @click="sendRequest">Proceed</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import CommonService from "../services/CommonService";
import EmployeeUniformsService from "../../../../Uniforms/resources/js/service/EmployeeUniformsService";
import _ from "lodash";
import UniformsService from "../../../../Uniforms/resources/js/service/UniformsService";

export default {
    name: "EmployeeAddUniform",
    props: {
        idAdmin: Boolean,
        userName: String,
        userId: Number
    },
    data() {
        return {
            request: {
                employee_id: this.userId ?? null,
                uniforms: [],
                location: null,
                comment: null,
                isMainOffice: true,
            },
            uniform: {
                size: null,
                quantity: null,
            },
            searchTerm: null,
            showTypeInput: false,
            foundUniform: null,
            clientsList: [],
            showResults: false,
            filteredUniformsList: [],
        }
    },
    methods: {
        handleSearch() {
            this.delayedSearch();
        },
        delayedSearch: _.debounce(function () {
            this.searchUniformItem()
        }, 500),

        async searchUniformItem() {
            if (this.searchTerm || this.searchTerm.trim() !== '') {
                this.showResults = true
                try {
                    const {data: response} = await UniformsService.searchUniformInList(this.searchTerm)
                    this.filteredUniformsList = response.data
                } catch (e) {
                }
            }
        },
        addNewItem() {
            this.showTypeInput = true
        },
        async addExistingUniform(uniform) {

            this.request.uniforms.push({
                title: uniform.title,
                size: this.uniform.size,
                quantity: this.uniform.quantity,
                uniform_id: uniform.id
            })
            this.$showSuccessMessage('Item has been added')
            this.showTypeInput = false
            this.searchTerm = null
            this.uniform.size = null
            this.uniform.quantity = null
        },
        async getClientsList() {
            try {
                const {data: clients} = await CommonService.getClientsList()
                this.clientsList = clients
            } catch (e) {
                console.error()
                this.$showErrorMessage();
            }
        },
        async saveItem() {
            if (!this.uniform.quantity) {
                this.$showErrorMessage('It is impossible to save without quantity')
            } else if (!this.foundUniform) {
                this.$showErrorMessage('It is impossible to save without uniform. Please select from list')
            } else {
                await this.addExistingUniform(this.foundUniform);
            }

        },
        selectResult(result) {
            this.foundUniform = result
            this.searchTerm = result.title
            this.showResults = false
        },
        async sendRequest() {
            this.$showLoadingMessage()
            if (this.request.uniforms.length === 0) {
                this.$showErrorMessage('You didn\'t choose a uniform');
                return
            }
            try {
                await EmployeeUniformsService.sendNewRequest(this.userId, this.request)
                this.$showSuccessMessage('Item has been added')
                setTimeout(() => {
                    window.location.href = '/application/profile?tab=Uniforms'
                }, 1000)

            } catch (e) {
                this.$showErrorMessage();
            }
        },
        removeItem(item) {
            this.requestUniforms = this.requestUniforms.filter(uniform => uniform.uniform_id !== item.uniform_id);
        },
    },


    mounted() {
        this.getClientsList();
    }
}

</script>
<style scoped>
.search-results {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: none;
    z-index: 9999;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-height: 120px;
    overflow-y: auto;
}

.search-results li {
    border-bottom: 1px solid #ddd;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.search-results li:hover {
    background-color: #0d2d53;
    color: white;
    border-radius: 5px;

}

</style>
